import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string

export type NewsletterPayload = {
  email: string
}

export type NewsletterResponse =
  | { status: 202; response: 'EMAIL_ADDED' }
  | { status: 400; response: '3RD_PARTY_API_ERROR' }
  | { status: 401; response: '3RD_PARTY_API_AUTH_ERROR' }
  | { status: 409; response: 'ALREADY_SUBSCRIBED' }
  | { status: 422; response: 'INVALID_EMAIL' }
  | { status: 422; response: 'INVALID_LIST' }
  | { status: 429; response: '3RD_PARTY_API_ERROR' }
  | { status: 500; response: '3RD_PARTY_API_ERROR' }

export const signUpForNewsletter = (payload: NewsletterPayload): Promise<NewsletterResponse> => {
  payload['list'] = '5' // '5' WT newsletter token, '4' token for tests
  return promiseWrapper<NewsletterResponse, object>(
    `${USER_BASE_URL_WT}/api/public/subscribe-to-newsletter`,
    'POST',
    payload,
  )
}
